import { h } from 'preact';
import { useRef, useEffect } from 'preact/hooks';

const FitText = ({ product }) => {
  const targetScrollRef = useRef(null);
  const fitTextValue = product?.fitText?.value || product.fitText;

  if (!fitTextValue) {
    return null;
  }

  useEffect(() => {
    const targetScrollElement = document.querySelector('[data-target-scroll]');
    targetScrollRef.current = targetScrollElement;
  }, []);

  const handleClickScroll = () => {
    const header = document.querySelector('[data-section="header"]');
    const targetScroll = targetScrollRef.current;

    if (targetScroll && header) {
      const targetOffset = targetScroll.offsetTop - header.offsetHeight - 20;
      window.scrollTo({
        top: targetOffset,
        behavior: 'smooth',
      });
    }

    if (targetScroll) {
      const logicLabel = targetScroll.querySelector('label');
      const divElement = targetScroll.querySelector('div');

      if (logicLabel && divElement) {
        const computedStyles = window.getComputedStyle(divElement);
        const maxHeight = computedStyles.getPropertyValue('max-height');

        // eslint-disable-next-line radix
        if (!parseInt(maxHeight) > 0) {
          logicLabel.click();
        }
      }
    }
  };

  return targetScrollRef.current ? (
    <button
      className="body-3 text-text-subdued opacity-80 text-left"
      type="button"
      onClick={handleClickScroll}
    >
      {fitTextValue}
    </button>
  ) : (
    <div>{fitTextValue}</div>
  );
};

export default FitText;
